// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__kQJxx","colMin":"styles_colMin__Ip6K0","colCheckbox":"styles_colCheckbox__2VGjZ"};